const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

const isLocalApiUrl = (urlString) => {
  try {
    const parsed = new URL(urlString);
    return LOCAL_HOSTNAMES.has(parsed.hostname) || parsed.hostname.endsWith('.local');
  } catch {
    return false;
  }
};

export const getApiBaseUrl = () => {
  const envBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
  const envTunnelBaseUrl = (process.env.REACT_APP_API_BASE_URL_TUNNEL || '').trim();
  if (envBaseUrl && !isLocalApiUrl(envBaseUrl)) {
    return stripTrailingSlash(envBaseUrl);
  }

  if (envTunnelBaseUrl && !isLocalApiUrl(envTunnelBaseUrl)) {
    if (typeof window === 'undefined') {
      return stripTrailingSlash(envTunnelBaseUrl);
    }

    const currentHost = (window.location.hostname || '').trim();
    const isLocalHost = LOCAL_HOSTNAMES.has(currentHost) || currentHost.endsWith('.local');
    if (!isLocalHost && currentHost) {
      return stripTrailingSlash(envTunnelBaseUrl);
    }
  }

  if (typeof window !== 'undefined') {
    const currentHost = (window.location.hostname || '').trim();
    const isLocalHost = LOCAL_HOSTNAMES.has(currentHost) || currentHost.endsWith('.local');

    if (!isLocalHost && currentHost) {
      return `https://api.${currentHost}`;
    }
  }

  if (envBaseUrl) {
    return stripTrailingSlash(envBaseUrl);
  }

  return 'http://localhost:8000';
};
